import { Controller } from "@hotwired/stimulus"

// Live form-link detection for the admin reminder URL field. As the admin
// types or pastes, fetches the server-rendered preview fragment (which owns
// all URL-parsing and label logic) and injects it below the field. Debounced,
// and in-flight requests are aborted so a stale response can never overwrite
// a newer one.
export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { url: String, delay: { type: Number, default: 300 } }

  refresh() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.#load(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.abortController?.abort()
  }

  async #load() {
    this.abortController?.abort()

    const value = this.inputTarget.value.trim()
    if (value === "") {
      this.previewTarget.innerHTML = ""
      return
    }

    this.abortController = new AbortController()
    try {
      const response = await fetch(`${this.urlValue}?url=${encodeURIComponent(value)}`, {
        headers: { Accept: "text/html" },
        signal: this.abortController.signal
      })
      if (response.ok) this.previewTarget.innerHTML = await response.text()
    } catch (error) {
      if (error.name !== "AbortError") throw error
    }
  }
}
